import { forwardRef, type SVGProps } from "react";

/**
 * Document-with-folded-corner + "PDF" label, drawn in lucide's stroke style
 * (24×24 viewBox, currentColor, strokeWidth 2) so it composes with lucide
 * icons. Lucide itself has no PDF glyph.
 */
export const PdfFileIcon = forwardRef<
  SVGSVGElement,
  SVGProps<SVGSVGElement> & { size?: number | string }
>(({ size = 24, ...props }, ref) => (
  <svg
    ref={ref}
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
    {...props}
  >
    <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
    <path d="M14 2v4a2 2 0 0 0 2 2h4" />
    <text
      x="12"
      y="17.5"
      textAnchor="middle"
      fontSize="7"
      fontWeight="700"
      fill="currentColor"
      stroke="none"
      fontFamily="ui-sans-serif, system-ui, sans-serif"
    >
      PDF
    </text>
  </svg>
));
PdfFileIcon.displayName = "PdfFileIcon";
